/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.crypto2

/**
 * Any exception initiated by crypto2 library has this base class
 */
open class Crypto2Exception(text: String,cause: Throwable?=null): RuntimeException(text, cause)

class DecryptionFailedException(text: String="can't decrypt: wrong key or tampered message",
                                cause: Throwable?=null): Crypto2Exception(text,cause)

class NonceOutOfBoundsException(text: String): Crypto2Exception(text)

@Suppress("unused")
class NotSupportedException(text: String="operation is not supported for this object")
    : Crypto2Exception(text, null)

class IncorrectPasswordException(): Crypto2Exception("Incorrect password")